  

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</head>

  <br>
  <br>
  <br>
  <br>

  <div class="row p-3">
<div class="col-md-4 " style="font-weight: 800;" >
<img src="../../assets/Image/OrgCoral_Ofc-02_Concept-04.jpg" style="width: 100%;"  alt="" srcset="">
</div>






    <div style="padding-right: 10%;" class="col-md-8"    >
       <h2 style="color: #5170ff;" >Sign Up</h2>
<form [formGroup]="submitForm" class="row" >
  <div class="col-md-4 mt-3">
    <label for="formGroupExampleInput" class="form-label">First Name  &  Last Name*  
     
    </label>
    <input type="text" class="form-control" formControlName="name" id="formGroupExampleInput" pattern="^[A-Za-z0-9\s]*$" placeholder="Firstname & lastname">
     <span style="color: red;font-size: small;" *ngIf="name?.errors?.['required'] && name?.touched " >(Kindly Enter The Name)</span>
      <span style="color: red;font-size: small;" *ngIf="name?.errors?.['pattern'] && name?.touched " >(Kindly Enter The Valid Name)</span>
      
  </div>
  <div class="col-md-4 mt-3">
    <label for="formGroupExampleInput2" class="form-label">Business Email* 
     
    </label>
    <input type="text" class="form-control" formControlName="email"  pattern="^[-A-Za-z0-9!#$%&'*+/=?^_`{|}~]+(?:\.[-A-Za-z0-9!#$%&'*+/=?^_`{|}~]+)*@(?:[A-Za-z0-9](?:[-A-Za-z0-9]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[-A-Za-z0-9]*[A-Za-z0-9])?$"  id="formGroupExampleInput2" placeholder="Business Email">
     <span style="color: red;font-size: small;" *ngIf="email?.errors?.['required'] && email?.touched " >(Kindly Enter The E-Mail)</span>
      <span style="color: red;font-size: small;" *ngIf="email?.errors?.['pattern'] && email?.touched " >(Kindly Enter The Valid E-Mail)</span>
  </div>
  <div class="col-md-4 mt-3">
    <label for="formGroupExampleInput2" class="form-label">Mobile Number*
      
    </label>
    <input (change)="getCaptcha()" type="text" class="form-control" formControlName="mobileNumber" minlength="10" maxlength="10"  pattern="^[0-9]+$"  id="formGroupExampleInput2" placeholder="MobileNumber">
    <span style="color: red;font-size: small;" *ngIf="mobileNumber?.errors?.['required'] && mobileNumber?.touched " >(Kindly Enter The MobileNumber)</span>
      <span style="color: red;font-size: small;" *ngIf="mobileNumber?.errors?.['pattern'] && mobileNumber?.touched " >(Kindly Enter The Valid MobileNumber)</span>
  </div>

   
<div class="col-md-3 mt-3">
<label for="formGroupExampleInput2" class="form-label">State Name*
  
  
</label>
    <input type="text" class="form-control" formControlName="stateName" id="formGroupExampleInput" pattern="^[A-Za-z0-9\s]*$" placeholder="State Name">
  <span style="color: red;font-size: small;" *ngIf="stateName?.errors?.['required'] && stateName?.touched " >(Kindly Enter The State)</span>
      <span style="color: red;font-size: small;" *ngIf="stateName?.errors?.['pattern'] && stateName?.touched " >(Kindly Enter The Valid State Name)</span>  


</div>
   
  <div class="col-md-3 mt-3">
    <label for="formGroupExampleInput2" class="form-label">Country Name*
     
    </label>

    <input class="form-control" rows="3"  pattern="^[A-Za-z0-9\s\-\,\.]*$"  formControlName="countryName"   placeholder="Country Name" id="floatingTextarea">
     <span style="color: red;font-size: small;" *ngIf="countryName?.errors?.['required'] && countryName?.touched " >(Kindly Enter The Country Name)</span>
      <span style="color: red;font-size: small;" *ngIf="countryName?.errors?.['pattern'] && countryName?.touched " >(Kindly Enter The Valid Country Name)</span>
  </div>

  <div class="col-md-3 mt-3">
    <label for="formGroupExampleInput2" class="form-label">City Name*
     
    </label>

    <input class="form-control" rows="3"  pattern="^[A-Za-z0-9\s\-\,\.]*$"  formControlName="cityName"   placeholder="Country Name" id="floatingTextarea">
     <span style="color: red;font-size: small;" *ngIf="cityName?.errors?.['required'] && cityName?.touched " >(Kindly Enter The Country Name)</span>
      <span style="color: red;font-size: small;" *ngIf="cityName?.errors?.['pattern'] && cityName?.touched " >(Kindly Enter The Valid Country Name)</span>
  </div>
<div class="col-md-3 mt-3">
    <label for="formGroupExampleInput2" class="form-label">Pincode*
     
    </label>

    <input class="form-control" rows="3" minlength="6" maxlength="6" pattern="^[0-9\s]*$"  formControlName="pincode"   placeholder="Pincode" id="floatingTextarea">
     <span style="color: red;font-size: small;" *ngIf="pincode?.errors?.['required'] && pincode?.touched " >(Kindly Enter The Country Name)</span>
      <span style="color: red;font-size: small;" *ngIf="pincode?.errors?.['pattern'] && pincode?.touched " >(Kindly Enter The Valid Country Name)</span>
  </div>
  <div class="col-md-12 mt-3">
    <label for="formGroupExampleInput2" class="form-label">Address*
     
    </label>

    <textarea class="form-control" rows="3"  pattern="^[A-Za-z0-9\s\-\,\.]*$"  formControlName="address"   placeholder="Address" id="floatingTextarea"></textarea>
     <span style="color: red;font-size: small;" *ngIf="address?.errors?.['required'] && address?.touched " >(Kindly Enter The Addresss)</span>
      <span style="color: red;font-size: small;" *ngIf="address?.errors?.['pattern'] && address?.touched " >(Kindly Enter The Valid Addresss)</span>
  </div>
  

  <div class="col-md-8 mt-3" *ngIf="receivedCaptcha" >
    <label for="formGroupExampleInput2" class="form-label">Enter Captcha*
      <!-- <span style="color: red;font-size: small;" *ngIf="captcha?.errors?.['pattern'] && captcha?.touched " >(Kindly Enter The Valid countryNames)</span> -->
    </label>
<div class="input-group" >
  <input class="form-control captcha barriecito-regular " ondrag="return false"  readonly (copy)="false"  [value]="receivedCaptcha"  id="floatingTextarea">
<button class="btn btn" (click)="getCaptcha()" style="background-color: #5170ff;color: white" >
  <i class="bi bi-arrow-clockwise"></i>
</button>
<input class="form-control" formControlName="captcha" (paste)="false" pattern="^[A-Za-z0-9\s\-\,\.]*$"    placeholder="Enter Captcha Here" >
      <span style="color: red;font-size: small;" *ngIf="captcha?.errors?.['required'] && captcha?.touched " >(Kindly Enter The Captcha)</span>

</div>
  </div>
  
<div class="text-end mt-3 "  >
<button *ngIf="!loading"  (click)="submit()" style="background-color: #5170ff;color: white;" class="btn btn">Get OTP</button>
  <button *ngIf="loading" disabled style="background-color: #5170ff;color: white;" class="btn btn">Loading . . . .     </button>
</div>
  

</form>


    </div>

    
  </div>